<script>

import {fetchTeam} from "../Data/data.js";
import TeamExtraCards from "./TeamExtraCards.svelte";


function show(){
    document.querySelectorAll('.memberHidde').forEach(el => {el.style.display = 'block';});
    document.querySelectorAll('.btnShow').forEach(el => {el.style.display = 'none';});
    document.querySelectorAll('.btnHidde').forEach(el => {el.style.display = 'flex';});
};

function hidde(){
    document.querySelectorAll('.memberHidde').forEach(el => {el.style.display = 'none';});
    document.querySelectorAll('.btnShow').forEach(el => {el.style.display = 'flex';});
    document.querySelectorAll('.btnHidde').forEach(el => {el.style.display = 'none';});
};

let gridWidth;
let cardWidth;
let numTeamMembers;

$: if (Math.floor(gridWidth / (cardWidth)) % 2 === 0) {
    numTeamMembers = 4;
}else {
    numTeamMembers = 3;
}

</script>

<section id="time">
    <div class="team">

        <TeamExtraCards/>

        <div class="tittle_div">

            <div class="tittle_cardContainer">
                <div class="tittle_card">
                    Time
                </div>
            </div>

        </div>


        {#await fetchTeam()}
            <p>Espere por favor</p>

            {:then members}

            <div class="member_cardContainer" bind:clientWidth={gridWidth}>

            {#each members as Team_member, i}

                <div class="member" class:memberHidde={ i >= numTeamMembers} bind:clientWidth={cardWidth} on:click={()=>{}}>
                    <div class="face1">
                        <div class="memberImg">
                            <img src={Team_member.image} alt="city">
                        </div>
                        <div class="description">
                            <h2>{Team_member.name}</h2>
                            <p>{Team_member.position}</p>
                        </div>
                    </div>

                    <div class="face2">
                        <div class="info">
                            <h2>Biografia</h2>
                            <p>{Team_member.biography}</p>
                        </div>
                    </div>

                </div>

            {/each}

            </div>

            {#if !(numTeamMembers >= members.length)}
                <div class="btnContainer">
                    <button class="btn btnShow" on:click={show}>
                        <div class="icon">
                            <svg width="19" height="13" viewBox="0 0 19 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M9.5 0C5.18182 0 1.49409 2.69533 0 6.5C1.49409 10.3047 5.18182 13 9.5 13C13.8182 13 17.5059 10.3047 19 6.5C17.5059 2.69533 13.8182 0 9.5 0ZM9.5 10.8333C7.11636 10.8333 5.18182 8.892 5.18182 6.5C5.18182 4.108 7.11636 2.16667 9.5 2.16667C11.8836 2.16667 13.8182 4.108 13.8182 6.5C13.8182 8.892 11.8836 10.8333 9.5 10.8333ZM9.5 3.9C8.06636 3.9 6.90909 5.06133 6.90909 6.5C6.90909 7.93867 8.06636 9.1 9.5 9.1C10.9336 9.1 12.0909 7.93867 12.0909 6.5C12.0909 5.06133 10.9336 3.9 9.5 3.9Z" fill="#333333"/>
                            </svg>
                        </div>
                        <div class="btn-text">Ver o time completo</div>
                    </button>

                    <button class="btn btnHidde" on:click={hidde}>
                        <div class="icon">
                            <svg width="19" height="13" viewBox="0 0 19 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M9.5 0C5.18182 0 1.49409 2.69533 0 6.5C1.49409 10.3047 5.18182 13 9.5 13C13.8182 13 17.5059 10.3047 19 6.5C17.5059 2.69533 13.8182 0 9.5 0ZM9.5 10.8333C7.11636 10.8333 5.18182 8.892 5.18182 6.5C5.18182 4.108 7.11636 2.16667 9.5 2.16667C11.8836 2.16667 13.8182 4.108 13.8182 6.5C13.8182 8.892 11.8836 10.8333 9.5 10.8333ZM9.5 3.9C8.06636 3.9 6.90909 5.06133 6.90909 6.5C6.90909 7.93867 8.06636 9.1 9.5 9.1C10.9336 9.1 12.0909 7.93867 12.0909 6.5C12.0909 5.06133 10.9336 3.9 9.5 3.9Z" fill="#333333"/>
                            </svg>
                        </div>
                        <div class="btn-text">Ocultar</div>
                    </button>
                </div>
            {/if}

        {/await}
    </div>
</section>

<style lang="scss">
    @use "../styles/variables" as v;

    :root {
        --gap: 1em;
    }

    .team {
        padding-bottom: 7em;
    }

    .tittle_div {
        padding: 5em 1em 3em 1em;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .tittle_card {
        color: v.$clr-grey;
        border: 2px solid #333333;
        border-radius: 30px;
        padding: 0.5em 3.5em;
        font-weight: 400;
        font-size: 1.714rem;
        text-transform: uppercase;
    }


    .member_cardContainer {
        display: grid;
        grid-auto-flow: row;
        grid-template-columns: repeat(auto-fit, minmax(18em, 1fr));
        gap: var(--gap);
        width: 90%;
        max-width: 100em;
        margin: 0 auto;
        padding: 0.5em 0;
    }

    .memberHidde {
        display: none;
        transition: 1s all;
    }

    .member {
        position: relative;
        width: 18em;
        margin: 0 auto;
        border: 2px solid #333333;
        border-radius: 30px;

        .face2 {
            position: absolute;
            top: 0;
            left: 0;
            border: 1px solid transparent;
            border-radius: 30px;
            opacity: 0;
            height: 100%;
            transition: 0.3s all;
            overflow: hidden;

            .info {
                height: 100%;
            }

            h2,p {
                font-size: 1.28rem;
                font-weight: 700;
                color: v.$clr-grey;
                text-align: center;
            }

            p {
                font-size: 1rem;
                text-align: left;
                padding: 1rem 1rem 1.5rem 1rem;
                height: 100%;
                font-weight: 400;
                overflow-y: auto;
            }
        }
    }

    .member:hover {

        .face2 {
            display: block;
            background-color: white;
            opacity: 1;
        }
    }


    .memberImg,
    .description {
        width: 90%;
        margin: 0 auto;
    }

    .memberImg {
        padding: 1.2em 0;

        img {
            display: block;
            margin: 0 auto;
            width: 100%;
            height: auto;
            object-fit: cover;
        }
    }

    .description {
        padding-bottom: 2em;

        h2 {
            padding-bottom: 0.3em;
            font-size: 1.28rem;
            font-weight: 700;
            color: v.$clr-purple;
        }
        p {
            font-size: 1.2rem;
            font-weight: 400;
            color: v.$clr-grey;
        }
    }


    .btnContainer {
        padding-top: 2em;
    }

    .btn {
        color: #333333;
        cursor: pointer;
        width: fit-content;
        border: none;
        font-size:  1.28rem;
        font-weight: 700;
        background: transparent;
        display: flex;
        justify-content: center;
        align-items: center;
        white-space: nowrap;
        background: linear-gradient(90deg, #F5CFC2 0%, #8C66C9 100%);
        border-radius: 30px;
        padding: 0.5em 1em;
        font-size: 1.28rem;
        margin-left: auto;
        margin-right: auto;

        &-text {
            margin-left: 1em;
        }
    }

    .btnHidde {
        display: none;
    }

    @media only screen and (min-width: v.$md-desktop-devices) {

        .team {
            padding-bottom: 23em;
        }

        .tittle_div {
            padding: 10.3em 1em 5em 1em;
        }

        .member {
            flex: 1 0 21.5%;
            flex-grow: 0;
            display: block !important;
        }

        .memberHidde {
            display: block !important;
        }

        .btn {
            display: none !important;
        }

    }
</style>
